<template>
  <modal @close="closeModal" :displayCross="true"
  >
    <big-title :text="text.edges[0].node.title" :hasBlock="true" class="u-color--grey-dark title-info"/>
    <div v-html="text.edges[0].node.body"></div>
  </modal>
</template>

<script>
  import BigTitle from "../../Core/BigTitle";
  import Modal from "../Granular/Modal";
  export default {
    name: "Modal-infos",
    components: {Modal, BigTitle},
    props: ['text'],
    methods: {
      closeModal() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss">

  .modal-backdrop .modal {min-height:auto}
  .title-with-link h2 {
      margin: 0 1.25rem .2em 0;
  }

</style>